import React, { useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  TextareaAutosize,
  InputAdornment,
} from "@mui/material";
import { Facebook, Instagram, WhatsApp } from "@mui/icons-material";
import { motion } from "framer-motion";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import useInView from "../../hooks/useInView";

const ContactForm = ({ enterprise, categories }) => {
  const cardStyle = {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    maxWidth: "90%",
    margin: "0 auto",
    textAlign: "center",
    overflow: "hidden",
    minHeight: "27rem",
  };

  const textStyle = {
    fontSize: "1.1rem",
    lineHeight: "1.6",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  };

  const [isInViewContacto, refContacto] = useInView();
  const [isInViewFormulario, refFormulario] = useInView();
  const [isInViewMapa, refMapa] = useInView();
  const [formData, setFormData] = useState({
    nombreApellido: "",
    fechaInicio: "",
    cantidadDias: "",
    lugar: "",
    equipo: "",
    alturaTrabajo: "",
    tipoSuperficie: "",
    comentario: "",
  });

  const handleCotizar = () => {
    const message = `
      *Solicitud de Cotización*\n
      *Nombre y apellido:* ${formData.nombreApellido}\n
      *Fecha de inicio:* ${formData.fechaInicio}\n
      *Cantidad de días:* ${formData.cantidadDias}\n
      *Lugar:* ${formData.lugar}\n
      *Equipo:* ${formData.equipo ? formData.equipo : "No seleccionado"}\n
      *Altura de trabajo:* ${formData.alturaTrabajo} mts\n
      *Tipo de superficie:* ${formData.tipoSuperficie}\n
      *Comentarios:* ${formData.comentario}
    `;

    const phoneNumber = enterprise?.celular
      ? formatPhoneNumber(enterprise.celular)
      : "5491126485397";

    // Redirige a WhatsApp con el mensaje y número de teléfono
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function formatPhoneNumber(phone) {
    return phone.replace(/\D/g, ""); // Elimina todos los caracteres que no sean números
  }

  return (
    <div
      style={{ padding: "2rem", backgroundColor: "#f5f5f5" }}
      id="cotizacion"
    >
      <h2 className="section-title">Contacto y Cotización</h2>
      <Grid container spacing={4} justifyContent="center">
        {/* Información de Contacto */}
        <Grid item xs={12} md={6}>
          <motion.div
            ref={refContacto}
            initial={{ opacity: 0, y: 100 }}
            animate={
              isInViewContacto ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }
            }
            transition={{ duration: 0.8 }}
            style={cardStyle}
          >
            <h3
              style={{
                textTransform: "uppercase",
                marginBottom: "1rem",
                color: "#ff9933",
              }}
            >
              Contacto
            </h3>
            <p style={{ ...textStyle, marginBottom: "2rem" }}>
              Nos encantaría saber de vos. Contáctanos para más información
              sobre nuestros servicios o para obtener una cotización
              personalizada.
            </p>
            <Grid container spacing={2}>
              {/* Primera columna */}
              <Grid item xs={12} md={6}>
                <div style={{ marginBottom: "1.5rem" }}>
                  <h4
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0.5rem",
                      color: "#ff9933",
                    }}
                  >
                    Llamanos
                  </h4>
                  <p style={textStyle}>
                    <LocalPhoneOutlinedIcon style={{ marginRight: "5px" }} />{" "}
                    {enterprise?.telefono
                      ? enterprise.telefono
                      : "(011) 2198-7421"}
                  </p>
                  <p style={textStyle}>
                    <WhatsAppIcon style={{ marginRight: "5px" }} />
                    {enterprise?.celular
                      ? enterprise.celular
                      : "+54 9 (11)-2648-5397"}
                  </p>
                </div>
                <div>
                  <h4
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0.5rem",
                      color: "#ff9933",
                    }}
                  >
                    Escríbenos
                  </h4>
                  <p style={textStyle}>
                    <EmailOutlinedIcon style={{ marginRight: "5px" }} />
                    <a
                      href={`mailto:${
                        enterprise?.email || "infoelevacionesae@gmail.com"
                      }`}
                      style={{
                        color: "#1e90ff",
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      {enterprise?.email || "infoelevacionesae@gmail.com"}
                    </a>
                  </p>
                </div>
              </Grid>
              {/* Segunda columna */}
              <Grid item xs={12} md={6}>
                <div style={{ marginBottom: "1.5rem" }}>
                  <h4
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0.5rem",
                      color: "#ff9933",
                    }}
                  >
                    Nuestra Ubicación
                  </h4>
                  <div style={{ alignItems: "flex-start", fontSize: "1.1rem" }}>
                    <p>
                      <PlaceOutlinedIcon />
                      {enterprise?.direccion
                        ? enterprise.direccion
                        : "Brandsen 4763 B1702 - Ciudadela Buenos Aires Argentina"}
                    </p>
                  </div>
                </div>
                <div>
                  <h4
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0.5rem",
                      color: "#ff9933",
                    }}
                  >
                    Redes Sociales
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "1rem",
                      marginTop: "0.5rem",
                    }}
                  >
                    <a
                      href={
                        enterprise?.facebook
                          ? `https://www.facebook.com/${enterprise.facebook}/`
                          : "https://www.facebook.com/AutoelevadoresEcharrielevaciones/"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <Facebook
                        style={{ fontSize: "2rem", color: "#4267B2" }}
                      />
                    </a>
                    <a
                      href={
                        enterprise?.instagram
                          ? `https://www.instagram.com/${enterprise.instagram}/`
                          : "https://www.instagram.com/autoelevadoresecharri/"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <Instagram
                        style={{ fontSize: "2rem", color: "#E1306C" }}
                      />
                    </a>
                    <a
                      href={`https://wa.me/${
                        enterprise?.celular
                          ? formatPhoneNumber(enterprise.celular)
                          : "5491126485397"
                      }`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="WhatsApp"
                    >
                      <WhatsApp
                        style={{ fontSize: "2rem", color: "#25D366" }}
                      />
                    </a>
                  </div>
                </div>
              </Grid>
            </Grid>
          </motion.div>
        </Grid>

        {/* Formulario de Cotización */}
        <Grid item xs={12} md={6}>
          <motion.div
            ref={refFormulario}
            initial={{ opacity: 0, y: 100 }}
            animate={
              isInViewFormulario ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }
            }
            transition={{ duration: 0.8 }}
            style={cardStyle}
          >
            <h3 style={{ color: "#ff9933" }}>Formulario de Cotización</h3>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nombre y apellido"
                    name="nombreApellido"
                    value={formData.nombreApellido}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Fecha de Inicio"
                    name="fechaInicio"
                    value={formData.fechaInicio}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Cantidad de Días"
                    name="cantidadDias"
                    value={formData.cantidadDias}
                    onChange={handleChange}
                    inputProps={{ maxLength: 4 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Lugar"
                    name="lugar"
                    value={formData.lugar}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item sm={5} xs={12}>
                  <Select
                    fullWidth
                    defaultValue=""
                    name="equipo"
                    value={formData.equipo}
                    onChange={handleChange}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Seleccione un Equipo
                    </MenuItem>
                    {categories.map((c) => (
                      <MenuItem value={c.titulo} key={c?._id}>
                        {c.titulo}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={3.5}>
                  <TextField
                    fullWidth
                    label="Altura de Trabajo"
                    name="alturaTrabajo"
                    value={formData.alturaTrabajo}
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">mts</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item sm={3.5} xs={12}>
                  <TextField
                    fullWidth
                    label="Tipo de Superficie"
                    placeholder="(suelo firme, pasto, etc)"
                    name="tipoSuperficie"
                    value={formData.tipoSuperficie}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextareaAutosize
                    minRows={4}
                    placeholder="Comentario"
                    name="comentario"
                    value={formData.comentario}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={handleCotizar}
                    style={{
                      fontSize: "0.875rem",
                      padding: "0.5rem 1rem",
                      backgroundColor: "#ff9933",
                    }}
                  >
                    Cotizar
                  </Button>
                </Grid>
              </Grid>
            </form>
          </motion.div>
        </Grid>

        {/* Mapa de Google Maps */}
        <Grid item xs={12}>
          <motion.div
            ref={refMapa}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={
              isInViewMapa
                ? { opacity: 1, scale: 1 }
                : { opacity: 0, scale: 0.9 }
            }
            transition={{ duration: 0.8 }}
          >
            <iframe
              title="Ubicación"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.350895454097!2d-58.530078!3d-34.640768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc850c9e527fb%3A0x7ae761ba8aa76103!2sBrandsen%204763%2C%20B1702%20Ciudadela%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1618501366000!5m2!1ses!2sar"
              style={{
                border: "0",
                width: "100%",
                height: "400px",
                borderRadius: "8px",
              }}
              allowFullScreen=""
              loading="lazy"
            />
          </motion.div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ContactForm;
